import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiErr } from "@/api";
import { useAuth } from "@/context/AuthContext";
import { Brand, PoweredBy } from "@/components/Brand";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

const DEST = { jjs_admin: "/admin", superadmin: "/superadmin" };

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      const role = data.user.role;
      if (role !== "jjs_admin" && role !== "superadmin") {
        toast.error("This portal is for JJS administrators only.");
        setBusy(false);
        return;
      }
      login(data.token, role, data.user);
      toast.success(`Welcome, ${data.user.name}`);
      navigate(DEST[role]);
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="max-w-md mx-auto w-full px-4 h-16 flex items-center">
        <Brand />
      </header>
      <div className="max-w-md mx-auto w-full px-4 flex-1 flex flex-col justify-center pb-16">
        <div className="glass rounded-3xl p-7 fade-up gold-glow">
          <div className="h-12 w-12 rounded-2xl btn-dark flex items-center justify-center mb-5">
            <ShieldCheck size={20} className="text-white" />
          </div>
          <h1 className="font-display text-3xl gold-text">Administrator Access</h1>
          <p className="text-slate-400 text-sm mt-1">Restricted portal · JJS Admin & Super Admin</p>
          <form onSubmit={submit} className="space-y-4 mt-6">
            <div>
              <label className="text-xs uppercase tracking-wide text-slate-400">Email</label>
              <input data-testid="admin-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full mt-1 bg-black/30 gold-border rounded-xl px-4 py-3 text-slate-100 focus:outline-none focus:ring-2 focus:ring-[var(--jjs-gold)]" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wide text-slate-400">Password</label>
              <input data-testid="admin-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full mt-1 bg-black/30 gold-border rounded-xl px-4 py-3 text-slate-100 focus:outline-none focus:ring-2 focus:ring-[var(--jjs-gold)]" />
            </div>
            <button data-testid="admin-login-submit" disabled={busy} className="w-full btn-dark py-3 rounded-xl disabled:opacity-60">
              {busy ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
        <div className="mt-8"><PoweredBy /></div>
      </div>
    </div>
  );
}
